import { call, put, takeEvery, all } from 'redux-saga/effects'
import dashboardTypes from './dashboardTypes'
import {
  getQuickNumbersFailure,
  getQuickNumbersSuccess,
  getEventsFailure,
  getEventsSuccess
} from './dashboardActions'
import DashboardServices from '../../services/DashboardService'

export function * getQuickNumbers () {
  try {
    const response = yield call(DashboardServices.getQuickNumbers)
    yield put(getQuickNumbersSuccess(response.data))
  } catch (e) {
    yield put(getQuickNumbersFailure(e.message))
  }
}

export function * getEvents () {
  try {
    const response = yield call(DashboardServices.getEvents)
    yield put(getEventsSuccess(response.data))
  } catch (e) {
    yield put(getEventsFailure(e.message))
  }
}

export function * onGetQuickNumbers () {
  yield takeEvery(dashboardTypes.FETCH_QUICK_NUMBERS, getQuickNumbers)
}

export function * onGetEvents () {
  yield takeEvery(dashboardTypes.FETCH_EVENTS, getEvents)
}

export function * dashboardSaga () {
  yield all([
    call(onGetQuickNumbers),
    call(onGetEvents)
  ])
}
